module.exports = __webpack_public_path__ + "assets/img/home-zgyd-light.1da4b61e.png";